import type { Announcement } from '../types';

export const a_2026_05_15: Announcement = {
  id: '2026-05-15-mise-a-jour-produit',
  date: '2026-05-15',
  kicker: 'Mise à jour produit · 15 mai 2026',
  title: "Hector s'améliore",
  navLabel: 'Plan détaillé, assistants & actes famille',
  subtitle: "Ce qu'on a construit pour vous ces dernières semaines.",
  footer: {
    text: 'Une question sur ces nouveautés ?',
    cta: { label: 'Prendre rendez-vous', url: 'https://www.app.hector.legal/aide' },
  },
  // Ordre des sections = ordre d'affichage (AnnouncementModal mappe
  // `sections` tel quel). « Améliorations » en tête : la refonte
  // jurisprudence est la nouveauté la plus structurante (cf. mockup v11
  // validé — hiérarchie par l'ordre, lignes uniformes, pas d'encart).
  sections: [
    {
      label: 'Améliorations',
      features: [
        {
          id: 'plan-detaille',
          title: "Plan détaillé & génération d'actes",
          body: {
            kind: 'subpoints',
            subpoints: [
              {
                title: 'Recherche de jurisprudence améliorée',
                description:
                  "L'algorithme a été affiné pour remonter des décisions plus pertinentes au regard de votre dossier.",
              },
              {
                title: "Refonte de l'analyse de jurisprudence",
                description:
                  "Notre système d'analyse a été revu en profondeur : la description obtenue dans votre plan détaillé est plus fidèle et objective, et un filtre strict écarte les analogies et interprétations erronées.",
              },
            ],
          },
        },
        {
          id: 'assistants',
          title: 'Assistants Word & espace de travail plus performants',
          body: {
            kind: 'subpoints',
            subpoints: [
              {
                title: 'Meilleure gestion du contexte',
                description:
                  'Les deux assistants gèrent désormais plus finement leur contexte de travail sur les échanges longs.',
              },
              {
                title: 'Délégation à des sous-agents',
                description:
                  "Vous pouvez désormais demander à l'assistant d'invoquer des sous-agents pour réaliser certaines tâches, notamment l'analyse de la recherche de jurisprudence.",
              },
              {
                title: 'Actions rapides & compétences revues',
                description:
                  "Les actions rapides et compétences des assistants ont été revues, notamment pour l'analyse de vos actes (assistant Word) ou l'identification de moyens sur votre dossier (assistant espace de travail).",
              },
            ],
          },
        },
      ],
    },
    {
      label: 'Nouvelles fonctionnalités',
      features: [
        {
          id: 'template-mode',
          title: "Partez d'un modèle pour générer vos actes",
          cta: { label: 'Voir la vidéo démo', url: 'https://www.app.hector.legal/aide/template-mode' },
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Dans le complément Word, vous pouvez désormais télécharger un de vos modèles d'actes, afin de lancer la génération depuis celui-ci.",
              "Hector reprend les moyens de droit, le style et le formatage de votre modèle, et adapte les faits et l'application à l'espèce aux pièces du nouveau dossier.",
            ],
          },
        },
        {
          id: 'nouveaux-actes',
          title: 'Nouveaux actes en droit de la famille',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Nous avons entièrement repensé l'arborescence des actes en droit de la famille. De nombreux nouveaux actes sont désormais disponibles : AOMP, incidents JME, ordonnance de protection en défense, référés et appel, en demande comme en défense. La matière est couverte de bout en bout.",
            ],
          },
        },
        {
          id: 'tamponnage',
          title: 'Interface de tamponnage des pièces revisitée',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Nous avons pris le temps de repenser le parcours afin de le rendre plus intuitif et d'offrir plus de personnalisation. Par exemple, vous pouvez désormais personnaliser pièce par pièce l'emplacement du tampon.",
            ],
          },
        },
      ],
    },
    {
      label: 'Robustesse & documentation',
      features: [
        {
          id: 'resilience',
          title: 'Application plus résiliente',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              'Travail de fond sur la stabilité des connexions : nettement moins de déconnexions pour les utilisateurs concernés, en particulier sur les opérations longues.',
            ],
          },
        },
        {
          id: 'doc',
          title: 'Documentation enrichie',
          cta: { label: "Consulter le centre d'aide", url: 'https://www.app.hector.legal/aide' },
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Le centre d'aide a été mis à jour, avec de nouvelles vidéos, pour vous aider à tirer le meilleur d'Hector.",
            ],
          },
        },
      ],
    },
  ],
};
